// extracted by mini-css-extract-plugin
export default {"playerSkin":"xW34t","videoPreview":"T8lNJ"};